import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import meImage from "../assets/me.png";

export default function Home() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          zIndex: 0,
          bottom: "40%",
          width: "100vw",
          overflow: "hidden",
          left: 0,
        }}
      >
        <Box
          component={motion.div}
          animate={{ x: [0, -2000] }}
          transition={{
            duration: 50,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            display: "flex",
            width: "max-content",
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Times New Roman", serif',
              fontSize: { xs: "200px", md: "320px" },
              fontWeight: 400,
              color: "text.primary",
              whiteSpace: "nowrap",
              userSelect: "none",
            }}
          >
            Theo Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Times New Roman", serif',
              fontSize: { xs: "200px", md: "320px" },
              fontWeight: 400,
              color: "text.primary",
              whiteSpace: "nowrap",
              userSelect: "none",
            }}
          >
            Theo Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;Theo
            Greenslade&nbsp;-&nbsp;Theo Greenslade&nbsp;-&nbsp;
          </Typography>
        </Box>
      </Box>
      <Box
        ml={{ xs: "50%", md: "33%" }}
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          height: "100%",
        }}
      >
        <Box
          component="img"
          src={meImage}
          alt="Theo Greenslade"
          height={{ xs: "75%", md: "85%" }}
          draggable="false"
          sx={{
            position: "relative",
            zIndex: 3,
            width: "auto",
            objectFit: "contain",
            objectPosition: "bottom",
            userSelect: "none",
            pointerEvents: "none",
          }}
        />
      </Box>
      <Box
        bottom={{ xs: 24, sm: 32 }}
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          gap: { xs: 1, sm: 2 },
          px: { xs: 3, md: 4 },
        }}
      >
        <Box
          zIndex={{ xs: 4, sm: 2 }}
          sx={{
            width: "100%",
            height: "2px",
            backgroundColor: "#ffffff",
            mb: 2,
            transition: "transform 0.5s",
          }}
        />
        <Box
          display="flex"
          gap={1}
          flexDirection={"column"}
          sx={{ zIndex: 4, userSelect: "none" }}
        >
          <Typography variant="h4" lineHeight={1.2}>
            Senior Full-Stack Software Engineer
          </Typography>

          <Typography
            variant="h4"
            lineHeight={1.2}
            display={{ xs: "none", sm: "flex" }}
          >
            "To software! The cause of—and solution to—all of life's problems!"
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
